import { render, staticRenderFns } from "./IFrameContainer.vue?vue&type=template&id=90342c7a"
import script from "./IFrameContainer.vue?vue&type=script&lang=js"
export * from "./IFrameContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports